<template>
  <div class="skel-card">
    <div class="skel skel-media"></div>
    <div class="skel-body">
      <div class="skel skel-line w-70"></div>
      <div class="skel skel-line w-40"></div>
      <div class="skel skel-line w-90"></div>
      <div class="skel skel-line w-60"></div>
      <div class="skel-chips">
        <div class="skel skel-chip"></div>
        <div class="skel skel-chip"></div>
        <div class="skel skel-chip"></div>
      </div>
      <div class="skel-price-row">
        <div class="skel skel-price"></div>
        <div class="skel skel-badge"></div>
      </div>
    </div>
    <div class="skel-footer">
      <div class="skel skel-btn"></div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.skel-card {
  background: #fff;
  border: 1px solid rgba(5, 22, 41,.08);
  border-radius: 20px;
  overflow: hidden;
}
.skel { background: #e9edf5; border-radius: 8px; position: relative; overflow: hidden; }
.skel::after {
  content: '';
  position: absolute; inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent);
  animation: skel-shimmer 1.3s infinite;
}
@keyframes skel-shimmer { 100% { transform: translateX(100%); } }
.skel-media { aspect-ratio: 16 / 9; border-radius: 0; }
.skel-body { padding: 1.25rem 1.25rem .5rem; }
.skel-line { height: 12px; margin-bottom: .6rem; }
.w-70 { width: 70%; } .w-40 { width: 40%; } .w-90 { width: 90%; } .w-60 { width: 60%; }
.skel-chips { display: flex; gap: .5rem; margin: .3rem 0 .9rem; }
.skel-chip { width: 64px; height: 24px; border-radius: 99px; }
.skel-price-row {
  display: flex; align-items: center; gap: .6rem;
  padding-top: .6rem; border-top: 1px solid rgba(17,24,39,.06); margin-bottom: .35rem;
}
.skel-price { width: 90px; height: 28px; border-radius: 8px; }
.skel-badge { width: 84px; height: 20px; border-radius: 99px; }
.skel-footer { padding: .7rem 1.25rem 1.25rem; }
.skel-btn { height: 50px; border-radius: 12px; }
</style>
